<template>
  <div v-if="analyticsData">
    <!-- Key Statistics -->
    <b-row class="match-height">
      <b-col
        lg="3"
        sm="6"
      >
        <b-card class="text-center">
          <b-avatar
            size="45"
            variant="light-primary"
            class="mb-1"
          >
            <feather-icon
              size="21"
              icon="DollarSignIcon"
            />
          </b-avatar>
          <div class="truncate">
            <h3 class="mb-25 font-weight-bolder">
              {{ formatCurrency(analyticsData.totalRealizado) }}
            </h3>
            <span class="text-muted">Total Realizado</span>
          </div>
        </b-card>
      </b-col>
      <b-col
        lg="3"
        sm="6"
      >
        <b-card class="text-center">
          <b-avatar
            size="45"
            variant="light-success"
            class="mb-1"
          >
            <feather-icon
              size="21"
              icon="TrendingUpIcon"
            />
          </b-avatar>
          <div class="truncate">
            <h3 class="mb-25 font-weight-bolder">
              {{ analyticsData.percentualMeta }}%
            </h3>
            <span class="text-muted">Meta Atingida</span>
          </div>
        </b-card>
      </b-col>
      <b-col
        lg="3"
        sm="6"
      >
        <b-card class="text-center">
          <b-avatar
            size="45"
            variant="light-info"
            class="mb-1"
          >
            <feather-icon
              size="21"
              icon="UsersIcon"
            />
          </b-avatar>
          <div class="truncate">
            <h3 class="mb-25 font-weight-bolder">
              {{ formatCurrency(analyticsData.ticketMedio) }}
            </h3>
            <span class="text-muted">Ticket Médio</span>
          </div>
        </b-card>
      </b-col>
      <b-col
        lg="3"
        sm="6"
      >
        <b-card class="text-center">
          <b-avatar
            size="45"
            variant="light-warning"
            class="mb-1"
          >
            <feather-icon
              size="21"
              icon="TargetIcon"
            />
          </b-avatar>
          <div class="truncate">
            <h3 class="mb-25 font-weight-bolder">
              {{ formatCurrency(analyticsData.totalPrevisto) }}
            </h3>
            <span class="text-muted">Total Previsto</span>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <!-- Arrecadação por Mês -->
      <b-col md="8">
        <b-card title="Arrecadação Mensal">
          <vue-apex-charts
            type="area"
            height="350"
            :options="arrecadacaoOptions"
            :series="arrecadacaoSeries"
          />
        </b-card>
      </b-col>

      <!-- Status Participantes -->
      <b-col md="4">
        <b-card title="Status Participantes">
          <vue-apex-charts
            type="donut"
            height="350"
            :options="statusOptions"
            :series="statusSeries"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
  <div
    v-else
    class="text-center p-5"
  >
    <b-spinner variant="primary" />
    <p class="mt-1">
      Carregando indicadores...
    </p>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAvatar, BSpinner,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    BSpinner,
    VueApexCharts,
  },
  props: ['eventoId'],
  data() {
    return {
      analyticsData: null,
      arrecadacaoOptions: {
        chart: { toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: { categories: [] },
        yaxis: { labels: { formatter: val => this.formatCurrency(val) } },
        colors: ['#7367f0'],
      },
      statusOptions: {
        labels: [],
        legend: { position: 'bottom' },
        plotOptions: { pie: { donut: { size: '70%' } } },
      },
    }
  },
  computed: {
    arrecadacaoSeries() {
      if (!this.analyticsData) return []
      return [{
        name: 'Arrecadação',
        data: Object.values(this.analyticsData.arrecadacaoPorMes),
      }]
    },
    statusSeries() {
      if (!this.analyticsData) return []
      return Object.values(this.analyticsData.statusParticipantes)
    },
  },
  created() {
    this.fetchAnalytics()
  },
  methods: {
    async fetchAnalytics() {
      try {
        const { data } = await this.$http.get(`/evento/eventos/${this.eventoId}/analytics`)
        this.analyticsData = data

        // Update Options
        this.arrecadacaoOptions.xaxis.categories = Object.keys(data.arrecadacaoPorMes)
        this.statusOptions.labels = Object.keys(data.statusParticipantes)
      } catch (e) {
        this.$toast.error('Erro ao carregar analytics')
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0)
    },
  },
}
</script>
